import { KText } from '@/ui-library/components';
import { Flex } from '@chakra-ui/react';
import { SearchFilter } from '../filters/components';

export const CopyTemplateHeader = ({
  modalConfig = {},
  filters = {},
  setFilters = () => {},
}) => {
  const {
    modalTitle = 'Copy from another job',
    modalDescription = 'Import your Job Description from another job',
  } = modalConfig;

  return (
    <Flex justifyContent="space-between" p="xl">
      <Flex gap=".5rem">
        <Flex flexDir="column" gap=".5rem">
          <KText size="md-medium" color="secondary-900">
            {modalTitle}
          </KText>
          <KText fontSize="sm" fontWeight="400" color="secondary-700">
            {modalDescription}
          </KText>
        </Flex>
      </Flex>
      <SearchFilter
        hideSearchFullView={false}
        searchTerm={filters?.name}
        isCustomSearch={true}
        onCustomSearch={(searchTerm) =>
          setFilters((prev) => ({ ...prev, name: searchTerm }))
        }
      />
    </Flex>
  );
};
